import { z } from 'zod';
import { colorSchemeSchema, roleSchema } from './common.js';
import { passwordSchema, pinSchema } from './auth.js';
export const avatarColorSchema = z.string().regex(/^[a-z-]{2,24}$/, 'Ungueltige Avatarfarbe');
export const createUserSchema = z.object({
    name: z.string().min(1, 'Name ist Pflicht').max(60),
    email: z.string().email('Ungueltige E-Mail').max(254).optional().nullable(),
    password: passwordSchema,
    pin: pinSchema.optional().nullable(),
    role: roleSchema.default('member'),
    avatarColor: avatarColorSchema.optional(),
});
/** Admin-Sicht: darf Rolle, Aktivierung, Passwort und PIN setzen. */
export const adminPatchUserSchema = z
    .object({
    name: z.string().min(1).max(60).optional(),
    email: z.string().email().max(254).nullable().optional(),
    password: passwordSchema.optional(),
    pin: pinSchema.nullable().optional(),
    role: roleSchema.optional(),
    isActive: z.boolean().optional(),
    avatarColor: avatarColorSchema.optional(),
    themeId: z.string().min(1).max(40).optional(),
    colorScheme: colorSchemeSchema.optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Keine Aenderung angegeben' });
/** Selbst-Sicht: kein Rollen- oder Aktivierungswechsel. */
export const selfPatchUserSchema = z
    .object({
    name: z.string().min(1).max(60).optional(),
    password: passwordSchema.optional(),
    currentPassword: z.string().min(1).max(256).optional(),
    avatarColor: avatarColorSchema.optional(),
    themeId: z.string().min(1).max(40).optional(),
    colorScheme: colorSchemeSchema.optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Keine Aenderung angegeben' })
    .refine((v) => !v.password || Boolean(v.currentPassword), {
    message: 'Aktuelles Passwort zur Bestaetigung angeben',
    path: ['currentPassword'],
});
//# sourceMappingURL=user.js.map